import { AppConfig, NexusConfig } from '@virtus/common/auth';
//import { AppConfig, B2CConfig, NexusConfig } from '@virtus/common/src/auth';
import { IDPConfig } from '@virtus/common/auth';
import { DefaultProfileConfig } from 'src/comps/UserProfile/UserProfile';
interface AddminAADConfig {
  appName: string;
  clientId: string;
  tenantId: string;
  userLoginApiUrl: string;
  loginId?: string;
  dataEnvironment: string;
}
export interface AdminAppConfig extends Omit<Required<AppConfig>, 'b2c'> {
  adminConfig: NexusConfig;
  defaultProfile: DefaultProfileConfig;
  appInsightsKey: string;
  unauthorizedTextMessage: string;
  storageAccount: string;
  container: string;
  idp?: IDPConfig;
  useIDP: boolean;
  aad: AddminAADConfig;
  useAD: boolean;
  b2c?: any;
}

/**
 * returns correct Config object depending on __ENVIRONMENT__
 *
 * Using "if" statements other environments should be tree-shaked by webpack and not appear in bundled js
 */
const getConfig = (): AdminAppConfig => {
  if (__ENVIRONMENT__ === 'local' || __ENVIRONMENT__ === 'dev') {
    const sessionTimeout: number = __ENVIRONMENT__ === 'local' ? 180 * 60 * 1000 : 15 * 60 * 1000;
    return {
      useIDP: false,
      useAD: true,
      adminConfig: {
        baseURL: 'https://devnext.virtusllc.net/VirtusAdminAppApi',
        signalrUrl: 'https://devnext.virtusllc.net/SignalR/SignalRHub',
        signalrClientId: '52facf19-6786-4ff6-925d-5d7117e70273',
        signalrApiUrl: 'https://devnext.virtusllc.net/SignalR/api',
        registerURL:
          __ENVIRONMENT__ === 'dev' ? 'https://admin.virtusconnect.com/register' : 'http://localhost:4001/register',
        dataEnvironment: 'dev',
        sessionTimeOut: sessionTimeout,
      },
      aad: {
        appName: 'Virtus Admin Web App',
        clientId: '6898c080-9396-43f0-abe0-3a359760a8c6',
        userLoginApiUrl: 'https://devnext.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        tenantId: 'e3ff91d8-34c8-4b15-a0b4-18910a6ac575',
        dataEnvironment: 'dev',
      },
      defaultProfile: {
        DefaultGridRows: 25,
        DefaultTimeRange: 'P24H',
        DefaultUseSignalR: false,
      },
      appInsightsKey: '',
      unauthorizedTextMessage:
        'You are not authorized to use this application. Please contact Virtus Support if you require assistance.',
      storageAccount: 'deveus2devopsstorage',
      container: '$web',
    };
  }

  if (__ENVIRONMENT__ === 'qa') {
    return {
      useIDP: false,
      useAD: true,
      adminConfig: {
        baseURL: 'https://stgnext.virtusllc.net/VirtusAdminAppApi',
        signalrUrl: 'https://stgnext.virtusllc.net/SignalR/SignalRHub',
        signalrClientId: 'a0ebfe2d-9a90-444c-ba5d-22d2848f27bf',
        signalrApiUrl: 'https://stgnext.virtusllc.net/SignalR/api',
        registerURL: 'https://admin.virtusconnect.com/register',
        dataEnvironment: 'qa',
        sessionTimeOut: 15 * 60 * 1000,
      },
      aad: {
        appName: 'Virtus Admin Web App staging',
        clientId: '6898c080-9396-43f0-abe0-3a359760a8c6',
        userLoginApiUrl: 'https://stgnext.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        tenantId: 'e3ff91d8-34c8-4b15-a0b4-18910a6ac575',
        dataEnvironment: 'qa',
      },
      defaultProfile: {
        DefaultGridRows: 25,
        DefaultTimeRange: 'P24H',
        DefaultUseSignalR: false,
      },
      appInsightsKey: '',
      unauthorizedTextMessage:
        'You are not authorized to use this application. Please contact Virtus Support if you require assistance.',
      storageAccount: 'deveus2devopsstorage',
      container: '$web',
    };
  }

  if (__ENVIRONMENT__ === 'prod') {
    return {
      useIDP: false,
      useAD: true,
      adminConfig: {
        baseURL: 'https://next.virtusllc.net/VirtusAdminAppApi',
        signalrUrl: 'https://next.virtusllc.net/SignalR/SignalRHub',
        signalrClientId: 'a0ebfe2d-9a90-444c-ba5d-22d2848f27bf',
        signalrApiUrl: 'https://next.virtusllc.net/SignalR/api',
        registerURL: 'https://admin.virtusconnect.com/register',
        dataEnvironment: 'prod',
        sessionTimeOut: 15 * 60 * 1000,
      },
      aad: {
        appName: 'VirtusAdmin',
        clientId: '6898c080-9396-43f0-abe0-3a359760a8c6',
        userLoginApiUrl: 'https://next.virtusllc.net/UserLoginApi/api/UserLogin/DoLogin/',
        tenantId: 'e3ff91d8-34c8-4b15-a0b4-18910a6ac575',
        dataEnvironment: 'prod',
      },
      defaultProfile: {
        DefaultGridRows: 25,
        DefaultTimeRange: 'P24H',
        DefaultUseSignalR: false,
      },
      appInsightsKey: '',
      unauthorizedTextMessage:
        'You are not authorized to use this application. Please contact Virtus Support if you require assistance.',
      storageAccount: 'deveus2devopsstorage',
      container: '$web',
    };
  }

  throw new Error(`No config for __ENVIRONMENT__: '${__ENVIRONMENT__}'`);
};

const config = getConfig();
export default config;
